import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {MenuItem, FormControl, InputLabel, Select, IconButton} from '@material-ui/core';
import {ReactComponent as ArrowDownIcon} from '../../assets/icons/select-arrow.svg';
import {ReactComponent as ClearIcon} from '../../assets/icons/clearIcon.svg';
import {ReactComponent as ErrorIcon} from '../../assets/icons/error.svg';

import './SelectComponent.scss';

const SelectComponent = ({
  autoFocus = false,
  className = '',
  disabled = false,
  error,
  fullWidth = false,
  helperText,
  id,
  label,
  margin = 'none',
  name = '',
  onChange = () => {},
  options = [],
  required = false,
  placeholder = '',
  value = '',
  variant = 'outlined',
  alwaysOpen = false,
  inputProps = {},
  allowClear = true,
  ...props
}) => {
  const [open, setOpen] = useState(alwaysOpen);

  const handleClear = () => {
    onChange('');
  };

  return (
    <FormControl
      className={`select-component ${className}`}
      fullWidth={fullWidth}
      variant={variant}
      margin={margin}
      error={!!error}
      disabled={disabled}
      required={required}
    >
      {label && (
        <InputLabel htmlFor={id} className='select-component__label'>
          {label}
        </InputLabel>
      )}
      <Select
        autoFocus={autoFocus}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        IconComponent={ArrowDownIcon}
        {...props}
        placeholder={placeholder}
        className='select-component__select'
        endAdornment={
          value &&
          !disabled &&
          allowClear && (
            <IconButton size='small' onClick={handleClear} className={'select-component-clear'} disabled={disabled}>
              <ClearIcon />
            </IconButton>
          )
        }
        MenuProps={{
          PaperProps: {
            className: 'select-component__menu'
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },

          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          getContentAnchorEl: null
        }}
        inputProps={{
          ...inputProps,
          classes: {
            root: 'select-component__input',
            disabled: 'select-component__input--disabled'
          }
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
      {error && (
          <div className='input-mui__error-message'>
            <ErrorIcon/> {error}
          </div>
      )}
    </FormControl>
  );
};

SelectComponent.propTypes = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.node,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      name: PropTypes.node.isRequired
    })
  ),
  required: PropTypes.bool,
  value: PropTypes.any,
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  alwaysOpen: PropTypes.bool
};

export default SelectComponent;
